import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getFaqs } from "@/lib/api";
import { useSEO, breadcrumbSchema } from "@/lib/seo";
import PageHeader from "@/components/PageHeader";
import FaqAccordion from "@/components/FaqAccordion";
import { Reveal } from "@/components/motion/Reveal";
import { Link } from "react-router-dom";

export default function Faq() {
  const { data: faqs = [] } = useQuery({ queryKey: ["faqs"], queryFn: getFaqs });

  useSEO({
    title: "Frequently Asked Questions | Renova Peptide Co.",
    description:
      "Answers to common questions about ordering Renova Peptide Co. research materials, documentation, packaging, and our research-only positioning.",
    path: "/faq",
    jsonLd: [
      breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]),
      faqs.length
        ? {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.question,
              acceptedAnswer: { "@type": "Answer", text: f.answer },
            })),
          }
        : null,
    ].filter(Boolean),
  });

  return (
    <>
      <PageHeader
        overline="Support"
        title="Frequently Asked Questions"
        intro="Everything you need to know about ordering, documentation, and how Renova operates."
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]}
      />
      <section className="container-rnv py-16 md:py-20">
        <div className="max-w-3xl">
          <Reveal><FaqAccordion faqs={faqs} testIdPrefix="page-faq" /></Reveal>
          <Reveal delay={0.1}>
            <div className="mt-14 rounded-sm bg-white border border-[#1E2A44]/10 p-8 text-center">
              <h2 className="font-serif text-2xl text-[#1E2A44]">Still have a question?</h2>
              <p className="mt-2 text-sm text-[#85827D]">Our team is happy to help with order and product questions.</p>
              <Link to="/contact" className="btn-navy mt-6">Contact Us</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
